import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { WM_CTP_LOGO, WM_LW_LOGO } from '../../constants';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import WMLeftSectionResult from './WMLeftSectionResult';
import { graphql, QueryRenderer } from 'react-relay';
import environment from '../../environment';

const wmLeftSectionQuery = graphql`
    query WMLeftSectionQuery(
        $event_token: String!
        $guest_token: String!
        $quarter_id: Int!
        $page_number: Int
        $search_val: String
    ){
        ...WMLeftSectionResult_getLonewolfPersonalLeaderboardData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val)
    }
`

class WMLeftSection extends Component {
    constructor(props){
        super(props);
        this.state = {
            refetch: false,
        }

        this.refetchData = this.refetchData.bind(this);
    }

    refetchData(){
        this.setState(prevState => {
            return { refetch: !prevState.refetch };
        });
    }

    render(){
        const { classes, event_token, quarter_id, changePage, page_number, event_id } = this.props;
        const variables = { event_token: event_token, guest_token: ' ', quarter_id: quarter_id, page_number: page_number, refetch: this.state.refetch };

        return (
            <Grid item xs={6} className={classes.leftContainer}>
                <Grid container direction='row' justifyContent='center' alignItems='center' style={{marginTop: '2em'}}>
                    <img src={WM_CTP_LOGO} style={{height: '120px'}} />
                    <img src={WM_LW_LOGO} style={{height: '90px', marginLeft: '20px'}} />
                </Grid>
                <Grid container direction='column'>
                    <div className={classes.leftTitleContainer}>
                        <span className={classes.leftTitle}>LEADERBOARD</span>
                        <hr className={classes.wmHR} />
                    </div>
                    <QueryRenderer
                        environment={environment}
                        query={wmLeftSectionQuery}
                        variables={variables}
                        render={({ error, props}) => {
                            if(props){
                                return (
                                    <WMLeftSectionResult
                                        getLonewolfPersonalLeaderboardData={props}
                                        changePage={changePage}
                                        page_number={page_number}
                                        event_id={event_id}
                                        quarter_id={quarter_id}
                                        refetchData={this.refetchData}
                                    />
                                )
                            }
                        }}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default withStyles(useStyles)(WMLeftSection);